import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-subscription-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './subscription-card.component.html',
  styleUrl: './subscription-card.component.scss',
})
export class SubscriptionCardComponent {
  showSubscription = input(false);
  isSelected = input(false);
  showPromo = input(true);
  promoPoints = input<number>(0);
  pointsPerAmount = input<number>(800);
  disabled = input(false);

  payWithCard = output<void>();

  readonly termsUrl = 'https://www.sura.co/seguros/digitales/terminos-y-condiciones';
}
